'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _get = require('lodash/get');
var _isEmpty = require('lodash/isEmpty');
var _difference = require('lodash/difference');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(_isEmpty);
var _difference__default = /*#__PURE__*/_interopDefaultLegacy(_difference);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function round(value, step) {
  var inv = 1.0 / step;
  return Math.round(value * inv) / inv;
}
var calculateTotalAmount = function calculateTotalAmount(serviceItems, opts) {
  if (opts === void 0) {
    opts = {};
  }

  if (_isEmpty__default["default"](serviceItems)) {
    return 0;
  }

  var total = serviceItems.reduce(function (total, item) {
    var prices = calculateAmounts(item != null && item.grossAmount ? parseFloat((item == null ? void 0 : item.grossAmount) || 0) : parseFloat((item == null ? void 0 : item.feeAmount) || 0), Boolean(opts.includeGST && item.isTaxable));
    var itemTotal = undefined;

    if (opts.isSubTotal) {
      itemTotal = prices == null ? void 0 : prices.feeAmount;
    } else {
      itemTotal = prices == null ? void 0 : prices.grossAmount;
    }

    if (opts.includeDiscount && item.discountAmount) {
      var discountAmount = parseFloat(_get__default["default"](item, 'discountAmount', '0'));
      itemTotal -= discountAmount;
    }

    return total + itemTotal;
  }, 0);
  return total;
};
var calculateTotalDiscountAmount = function calculateTotalDiscountAmount(serviceItems) {
  return serviceItems.reduce(function (total, item) {
    return total + parseFloat(_get__default["default"](item, 'discountAmount', '0'));
  }, 0);
};
var calculateTotalGSTAmount = function calculateTotalGSTAmount(serviceItems, opts) {

  return serviceItems.reduce(function (total, item) {
    var prices = calculateAmounts(parseFloat((item == null ? void 0 : item.grossAmount) || 0), item.isTaxable);
    var gstAmount = prices == null ? void 0 : prices.taxAmount;
    return total + gstAmount;
  }, 0);
};
var applyDiscountToServiceItems = function applyDiscountToServiceItems(serviceItems, _ref) {
  var discount = _ref.discount,
      discountType = _ref.discountType;

  if (serviceItems && discount) {
    var totalAmount = calculateTotalAmount(serviceItems);
    var percentage = parseFloat(discount) / totalAmount;

    if (discountType === 'percentage') {
      percentage = parseFloat(discount) / 100;
    }

    return serviceItems.map(function (serviceItem) {
      return _objectSpread({}, serviceItem, {
        discountAmount: (serviceItem.feeAmount * percentage).toFixed(2)
      });
    });
  }

  return serviceItems;
};
var getEarliestServiceDate = function getEarliestServiceDate(serviceItems, dateKey) {
  if (dateKey === void 0) {
    dateKey = 'serviceDateString';
  }

  return serviceItems.reduce(function (currentEarliestDate, serviceItem) {
    if (!currentEarliestDate) {
      return serviceItem[dateKey];
    }

    if (Date.parse(serviceItem[dateKey]) < Date.parse(currentEarliestDate)) {
      return serviceItem[dateKey];
    }

    return currentEarliestDate;
  }, '');
};
var getChargeAmount = function getChargeAmount(serviceItems) {
  return calculateTotalAmount(serviceItems, {
    includeDiscount: true
  }).toFixed(2);
};
var getDiscountAmount = function getDiscountAmount(discountType, currentServiceItems, currentDiscountValue) {
  return discountType === 'price' ? parseFloat(currentDiscountValue).toFixed(2) : (calculateTotalAmount(currentServiceItems, {
    includeDiscount: false
  }) * (parseFloat(currentDiscountValue) / 100)).toFixed(2);
};
var getTotalAmount = function getTotalAmount(serviceItems) {
  return calculateTotalAmount(serviceItems, {
    includeDiscount: false
  }).toFixed(2);
};
var getItemValue = function getItemValue(item, opts) {
  var _ref2 = opts || {},
      _ref2$useBenefitAsPri = _ref2.useBenefitAsPrice,
      useBenefitAsPrice = _ref2$useBenefitAsPri === void 0 ? false : _ref2$useBenefitAsPri;

  var benefit = _get__default["default"](item, 'benefit', 0);

  var benefitAmount = (benefit / 100).toFixed(2);

  var price = _get__default["default"](item, 'price');

  var feeAmount = (price / 100).toFixed(2);
  var option = {
    label: item.displayName,
    value: item
  };
  return _objectSpread({
    service: option,
    quantity: 1
  }, item, {
    benefitAmount: benefitAmount,
    hasSeenPatientToday: 'no'
  }, price ? {
    feeAmount: feeAmount
  } : {
    feeAmount: undefined
  }, {}, useBenefitAsPrice && benefit > 0 ? {
    feeAmount: benefitAmount
  } : {});
};
function mapItemsToClaimItems(transaction) {
  var claimItems = _get__default["default"](transaction, 'claims[0].claimItems', []);

  var items = _get__default["default"](transaction, 'items', []);

  if (items.length === 0) {
    return claimItems;
  } // @ts-expect-error TS(7006): Parameter 'item' implicitly has an 'any' type.


  var newItems = items.map(function (item) {
    // @ts-expect-error TS(7006): Parameter 'claimItem' implicitly has an 'any' type... Remove this comment to see the full error message
    var claimItem = claimItems.find(function (claimItem) {
      return claimItem.itemId === item.itemId;
    }) || {};

    var isNonClaimable = _isEmpty__default["default"](claimItem);

    return _objectSpread({}, item, {}, claimItem, {
      displayName: _get__default["default"](item, 'displayName') || _get__default["default"](claimItem, 'displayName'),
      itemCode: _get__default["default"](claimItem, 'icare.itemCode') || _get__default["default"](claimItem, 'itemCode'),
      description: _get__default["default"](item, 'customDescription') || _get__default["default"](item, 'description') || _get__default["default"](claimItem, 'icare.description') || _get__default["default"](claimItem, 'description'),
      notes: _get__default["default"](item, 'description'),
      serviceDateString: (item == null ? void 0 : item.serviceDateString) || item.serviceDate,
      isNonClaimable: isNonClaimable
    });
  }); // @ts-expect-error TS(7006): Parameter 'claimItem' implicitly has an 'any' type... Remove this comment to see the full error message

  var claimItemIds = claimItems.map(function (claimItem) {
    return claimItem.claimItemId;
  }); // @ts-expect-error TS(7006): Parameter 'newItem' implicitly has an 'any' type.

  var newItemIds = newItems.map(function (newItem) {
    return newItem.claimItemId;
  });
  var extraItemIds = _difference__default["default"](claimItemIds, newItemIds) || [];
  var extraItems = extraItemIds.map(function (extraItemId) {
    // @ts-expect-error TS(7006): Parameter 'claimItem' implicitly has an 'any' type... Remove this comment to see the full error message
    var claimItem = claimItems.find(function (claimItem) {
      return claimItem.claimItemId === extraItemId;
    }); // @ts-expect-error TS(7006): Parameter 'item' implicitly has an 'any' type.

    var item = items.find(function (item) {
      return item.itemId === claimItem.itemId;
    });
    return _objectSpread({}, item, {}, claimItem, {
      displayName: _get__default["default"](claimItem, 'displayName'),
      itemCode: _get__default["default"](claimItem, 'icare.itemCode') || _get__default["default"](claimItem, 'itemCode'),
      description: undefined,
      notes: undefined,
      serviceDateString: (item == null ? void 0 : item.serviceDateString) || item.serviceDate,
      isExtraItem: true
    });
  });
  return [].concat(newItems, extraItems);
}
var calculateAmounts = function calculateAmounts(grossAmount, isTaxable) {
  var feeAmount = grossAmount;
  var taxAmount = 0;

  if (!isTaxable) {
    return {
      taxAmount: taxAmount,
      feeAmount: feeAmount,
      grossAmount: grossAmount
    };
  }

  feeAmount = feeAmount - feeAmount / 11;
  taxAmount = parseFloat((feeAmount * 1.1).toFixed(6)) - feeAmount;
  return {
    taxAmount: taxAmount,
    feeAmount: feeAmount,
    grossAmount: grossAmount
  };
};

exports.applyDiscountToServiceItems = applyDiscountToServiceItems;
exports.calculateAmounts = calculateAmounts;
exports.calculateTotalAmount = calculateTotalAmount;
exports.calculateTotalDiscountAmount = calculateTotalDiscountAmount;
exports.calculateTotalGSTAmount = calculateTotalGSTAmount;
exports.getChargeAmount = getChargeAmount;
exports.getDiscountAmount = getDiscountAmount;
exports.getEarliestServiceDate = getEarliestServiceDate;
exports.getItemValue = getItemValue;
exports.getTotalAmount = getTotalAmount;
exports.mapItemsToClaimItems = mapItemsToClaimItems;
exports.round = round;
